// extracted by mini-css-extract-plugin
export default {"container":"StatusLead_container__2x6TX","logo":"StatusLead_logo__4t4tZ","info":"StatusLead_info__Fpx2G","buttons":"StatusLead_buttons__Bk5dy"};